import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { FilterModel } from 'src/Models/filterModel';
import { RMDModel } from 'src/Models/TrfaAlertsModel';
import { TrfaAlertService } from 'src/Services/alert.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-rmd-alerts',
  templateUrl: './rmd-alerts.component.html',
  styleUrls: ['./rmd-alerts.component.css']
})
export class RmdAlertsComponent implements OnInit {

  tokenKey: string = '';
  isloading: boolean = false;
  filteModel = new FilterModel();;
  RMDModel: RMDModel[];
  RMDExportModel: RMDModel[];
  totalRecordCount: number = -1;
  isAscending: boolean;
  updateId: number = 0;

  upDownAlertDateCSS: string = '';
  upDownTitleCSS: string = '';
  upDownStatusCSS: string = '';
  upDownCreatedDateCSS: string = '';
  upDownModifiedDateCSS: string = '';
  Id: number = 0;
  IsSendEmail: boolean
  productId: number;
  SelectedTool: string;
  openMenuIndex: number = -1;

  constructor(private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly trfaAlertServices: TrfaAlertService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum.RMD;
    this.titleService.setTitle('RMD Alerts');
  }


  ngOnInit() {
    this.filteModel.pageNumber = '1';
    this.filteModel.pageSize = '10';
    this.filteModel.keywordFilter = '';
    this.filteModel.productId = this.productId;
    this.filteModel.orderBy = 'updateId ASC';
    this.filteModel.updateId = 0;
    this.GetRMDAlertsFindByPages();
  }

  GetRMDAlertsFindByPages() {
    this.isloading = true;
    this.RMDModel = [];
    if (this.filteModel.keywordFilter == "null") this.filteModel.keywordFilter = " ";

    this.filteModel.IsExport = false;
    this.trfaAlertServices.GetRMDAlertsFindByPages(this.tokenKey, this.filteModel).subscribe(data => {
      if (data['status'] == 'Success') {
        this.isloading = false;
        this.RMDModel = data['rmdAlertList'];
        if (this.RMDModel != null) {
          if (this.RMDModel.length > 0) {
            this.totalRecordCount = +this.RMDModel[0].totalRowCount;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      }
      else {
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  keywordFilters($event) {
    this.filteModel.keywordFilter = $event.target.value;
    //this.filteModel.pageNumber = '1';
    if ($event.target.value != "" && $event.target.value != null) {
      this.filteModel.keywordFilter = $event.target.value;
    }
    else { this.filteModel.keywordFilter = ''; }

    this.filteModel.pageNumber = '1';
    this.GetRMDAlertsFindByPages();
  }

  sort(sortBy: any) {
    this.upDownAlertDateCSS = '';
    this.upDownTitleCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filteModel.orderBy = sortBy + ' DESC';

      if (sortBy === "updateDate") {
        this.upDownAlertDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "providerName") {
        this.upDownTitleCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filteModel.orderBy = sortBy;

      if (sortBy === "updateDate") {
        this.upDownAlertDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "providerName") {
        this.upDownTitleCSS = 'fa fa-arrow-up';
      }
    }
    this.filteModel.pageNumber = '1';
    this.GetRMDAlertsFindByPages();
  }

  pageChanged($event) {
    this.filteModel.pageNumber = parseInt($event.page).toString();
    this.GetRMDAlertsFindByPages();
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  redirectToEditView(updateId: any) {
    this.router.navigate(['/admin/rmd/rmd-Alerts/user/' + updateId]);
  }

  SetCancelMailId(updateId: any) {
    this.Id = updateId;
  }

  CancelMail() {
    this.trfaAlertServices.notsentAlertmail(this.tokenKey, this.Id, this.productId).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.showMessage('', 'Success', 'success');
          this.GetRMDAlertsFindByPages();
        }
        else
          this.showMessage(data['status'], 'Error', 'error');
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportRMDAlert() {
    this.isloading = true;
    this.RMDExportModel = [];
    if (this.filteModel.keywordFilter == "null") this.filteModel.keywordFilter = " ";
    this.filteModel.IsExport = true;
    this.trfaAlertServices.GetRMDAlertsFindByPages(this.tokenKey, this.filteModel).subscribe(data => {
      if (data['status'] == 'Success') {
        this.RMDExportModel = data['rmdAlertList'];
        if (this.RMDExportModel != null) {
          if (this.RMDExportModel.length > 0) {
            setTimeout(() => {
              this.DownloadRMDAlert();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      }
      else {
        this.isloading = false;
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.isloading = false;
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  DownloadRMDAlert() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportRMDAlerts';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportRMDAlerts.xls");
  }

}
